$(document).on("ready", function () {
    let mainSection = $("section.main.photo_video");
    if(!mainSection.length) return;

    // Скрываем форму поиска на странице фото-видео
    $(".main-search-form-container").hide();
});
